import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  children: React.ReactNode;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#D4AF37] text-[#0A2540] hover:bg-[#B5952F] focus:ring-[#D4AF37]',
    secondary: 'bg-[#0A2540] text-white hover:bg-[#0F355A] focus:ring-[#0A2540]',
    outline: 'border-2 border-[#0A2540] text-[#0A2540] hover:bg-gray-50 focus:ring-[#0A2540]',
    ghost: 'text-[#0A2540] hover:bg-gray-100 focus:ring-[#0A2540]'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={isLoading} {...props} data-id="element-121">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-122" />}
      {children}
    </motion.button>;
}